import React, { useState } from 'react';
import { api } from '../services/api';

function Search() {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [systemId, setSystemId] = useState('');
  const [agent, setAgent] = useState('');
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSearched(true);
    try {
      const data = await api.search({
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        systemId: systemId || undefined,
        agent: agent || undefined,
      });
      setResults(data.recordings || []);
    } catch (err) {
      console.error('Search failed:', err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Search Recordings</h1>
        <p>Search across all phone systems by date, agent, or system</p>
      </div>

      <form className="search-form" onSubmit={handleSearch}>
        <input
          type="date"
          placeholder="From date"
          value={dateFrom}
          onChange={e => setDateFrom(e.target.value)}
        />
        <input
          type="date"
          placeholder="To date"
          value={dateTo}
          onChange={e => setDateTo(e.target.value)}
        />
        <select value={systemId} onChange={e => setSystemId(e.target.value)}>
          <option value="">All Systems</option>
          <option value="dialedin">DialedIn (Medicare)</option>
          <option value="pulsedial">PulseDial</option>
          <option value="vicidial">Vicidial</option>
          <option value="3cx-legacy">3CX Legacy</option>
        </select>
        <input
          type="text"
          placeholder="Agent ID"
          value={agent}
          onChange={e => setAgent(e.target.value)}
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Searching...' : 'Search'}
        </button>
      </form>

      {searched && (
        <>
          <p>{results.length} recording(s) found</p>
          <table className="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>System</th>
                <th>Agent</th>
                <th>Direction</th>
                <th>Original File</th>
                <th>Archived As</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {results.map((r, i) => (
                <tr key={i}>
                  <td>{r.recordDate}</td>
                  <td><span className={`system-tag ${r.systemId}`}>{r.systemId}</span></td>
                  <td>{r.agentId || '-'}</td>
                  <td>{r.direction || '-'}</td>
                  <td title={r.originalFilename}>{truncate(r.originalFilename, 30)}</td>
                  <td title={r.normalizedFilename}>{truncate(r.normalizedFilename, 30)}</td>
                  <td>
                    <span className={`badge badge-${r.processingResult === 'success' ? 'success' : 'danger'}`}>
                      {r.processingResult}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

function truncate(str: string, len: number): string {
  if (!str) return '-';
  return str.length > len ? str.substring(0, len) + '...' : str;
}

export default Search;
